module.exports = __webpack_public_path__ + "img/salud-denatl.f0d60639.png";